import {useQuery} from "@tanstack/react-query";
import {
    readDashboardSetting,
    readRevenueByItem, readRevenueByTeamByMonth,
    readRevenueByTeamByQuarter, readRevenueByTeamByYear
} from "../../../../../api/main/DashboardApi";
import {DashboardSettingSearchParamType} from "../interface";

export const useReadRevenueByTeamByMonth = () => {
    const {data} = useQuery({
        queryKey: ["readRevenueByTeamByMonth"],
        queryFn: async () => await readRevenueByTeamByMonth(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
